import { createContext, useContext } from 'react';
import { useAnalysis } from '../hooks/useAnalysis';
import { useUser } from './UserContext';
import { useCreditsContext } from './CreditsContext';

const AnalysisContext = createContext(null);

export function AnalysisProvider({ children, swingHistory, saveSwingToHistory }) {
  const { deviceId, isAdmin } = useUser();
  const { credits, setShowPricingModal, deductCredit } = useCreditsContext();

  const analysis = useAnalysis({
    deviceId,
    credits,
    isAdmin,
    setShowPricingModal,
    deductCredit,
    saveSwingToHistory,
    swingHistory,
  });

  return (
    <AnalysisContext.Provider value={analysis}>
      {children}
    </AnalysisContext.Provider>
  );
}

export function useAnalysisContext() {
  const context = useContext(AnalysisContext);
  if (!context) {
    throw new Error('useAnalysisContext must be used within an AnalysisProvider');
  }
  return context;
}
